import React from 'react';
import SearchParams from '../Elements/SearchParams';
import FreelancerFeeSearchParams from '../Contents/FreelancerInvoicing/FreelancerFees/FreelancerFeeSearchParams';
import FreelancerFeeItem from '../Domain/FreelancerFeeItem';
import AuthService from './authService.js';

class FreelancerFeeService extends React.Component {
  static GetFreelancerFeeList(orderById, orderDir, pageNumber, numberOfElements, searchItem, clearCache = false) {
    const searchParams = new SearchParams(searchItem, FreelancerFeeSearchParams, orderById, orderDir, pageNumber, numberOfElements);

    const url = `api/FreelancerFee/GetFreelancerFees?searchParams=${searchParams.serializeForBackendCall()}&clearCache=${clearCache}`;
    return AuthService.getInstance().CallBackendFunction(url);
  }

  static ConvertDBFreelancerFee(items) {
    const convertedItems = [];

    if (items !== null) {
      items.forEach((item) => {
        const newItem = new FreelancerFeeItem(item);
        convertedItems.push(newItem);
      });
    }

    return convertedItems;
  }

  static async EditCloneFreelancerFee(item) {
    if (item.FreelancerFeeId > 0) {
      const url = `api/FreelancerFee/PutFreelancerFee/${item.FreelancerFeeId}`;
      item = FreelancerFeeItem.CorrectingTypes(item);
      const editedItemJSON = JSON.stringify(item); //FreelancerFeeItem.ConvertToJSON(editedItem);

      return AuthService.getInstance().CallBackendFunctionPut(url, editedItemJSON);
    }
    return FreelancerFeeService.AddNewFreelancerFeeItem(item);
  }

  static async CloseFreelancerFee(editedItem) {
    const url = `api/FreelancerFee/CloseFreelancerFee/${editedItem.FreelancerUserId}`;
    editedItem = FreelancerFeeItem.CorrectingTypes(editedItem);
    const editedItemJSON = JSON.stringify(editedItem); //FreelancerFeeItem.ConvertToJSON(editedItem);

    return AuthService.getInstance().CallBackendFunctionPut(url, editedItemJSON);
  }

  static async AddNewFreelancerFeeItem(newItem) {
    const authService = AuthService.getInstance();

    const url = 'api/FreelancerFee/PostAsync';

    return authService.CallBackendFunctionPost(url, FreelancerFeeItem.ConvertToJSON(newItem));
  }

  static async ApplyFeeForEmployedFreelancersPostAsync(applyFeeItem) {
    applyFeeItem.Fee = applyFeeItem.Fee.toString();
    applyFeeItem.OptFee = applyFeeItem.OptFee.toString();
    applyFeeItem.FreelancerFeeId = applyFeeItem.FreelancerFeeId.toString();
    const authService = AuthService.getInstance();
    const url = 'api/FreelancerFee/ApplyFeeForEmployedFreelancersPostAsync';
    return authService.CallBackendFunctionPost(url, JSON.stringify(applyFeeItem));
  }

  static GetFreelancerFeeById(id) {
    return AuthService.getInstance().CallBackendFunction(`/api/FreelancerFee/GetFreelancerFeeById/${id}`);
  }
}

export default FreelancerFeeService;
